
/* @ngInject */
export default class PermissionsService {
    constructor(HPConfig, $http, $q) {
        this.HPConfig = HPConfig;
        this.$http = $http;
        this.$q = $q;
        this.permissions = null;
    }

    hasPermission(permissionName) {
        return _.find(this.permissions, permission => permission === permissionName) !== undefined;
    }

    getPermissions(attrs) {
        // attrs.fetchNewData - force fetch new data from the API
        // attrs.locationId - locationId to get permissions for
        attrs = attrs || {};

        const httpConfig = {
            params: {
                id: (attrs !== undefined && attrs.locationId !== undefined) ? attrs.locationId : 0,
            },
        };

        return this.$q((resolve) => {
            if (this.permissions === null || (attrs !== undefined && attrs.fetchNewData === true)) {
                this.$http.get(`${this.HPConfig.heroProApi}User/Permissions`, httpConfig).then((response) => {
                    this.permissions = (response.data.Permissions !== undefined) ? response.data.Permissions : [];
                    resolve(this.permissions);
                });
            } else {
                // Pass back data that is currently stored in the factory
                resolve(this.permissions);
            }
        });
    }
    setPermissions(newPermissions) {
        this.permissions = newPermissions;
    }
}


// export function permissionsFactory(_, HPConfig, $http, $q) {
// 	var _permissions = null;

//     return {
//         hasPermission: hasPermission,
//         getPermissions: getPermissions,
//         setPermissions: setPermissions
//     };

// 	function hasPermission(permissionName) {
//         return _.find(_permissions, function(permission) {
//             return permission === permissionName;
//         }) !== undefined;
//     }

//     function getPermissions(attrs) {
// 		// attrs.fetchNewData - force fetch new data from the API
//         // attrs.locationId - locationId to get permissions for
// 		attrs = attrs || {};

//         var httpConfig = {
//             params: {
//                 "id": (attrs !== undefined && attrs.locationId !== undefined) ? attrs.locationId : 0
//             }
//         };

//         return $q(function(resolve) {
// 			if(_permissions === null || (attrs !== undefined && attrs.fetchNewData === true)) {
// 				$http.get(HPConfig.heroProApi + "User/Permissions", httpConfig).then(function(response) {
//                     _permissions = (response.data.Permissions !== undefined) ? response.data.Permissions : [];
// 					resolve(_permissions);
// 				});
// 			}
// 			else {
// 				// Pass back data that is currently stored in the factory
// 				resolve(_permissions);
// 			}
// 		});
// 	}

//     function setPermissions(newPermissions) {
//         _permissions = newPermissions;
//     }
// }


// export default angular
// .module("HeroPRO")
// .factory("PermissionsFactory", permissionsFactory).name;



// WEBPACK FOOTER //
// ./src/app/common/angular/permissionsService.js